module.exports = __webpack_public_path__ + "static/media/location-icon.e52aed2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/location-icon.svg
// module id = 1470
// module chunks = 0